import { useEffect, useState } from 'react';

import { FEATURE } from '@/lib/constants/feature-notifications';
import { getStoredItem, setStoredItem } from '@/utils/store/local';
import { trackUser } from '@/utils/tracking';

const EVENT_TYPE = 'feature-update';

export type FeatureNotification = (typeof FEATURE)[keyof typeof FEATURE];

export const useFeatureNotifications = (feature?: FeatureNotification) => {
  const FEATURE_IDENTIFIER = 'feature';
  const [isFeatureSeen, setIsFeatureSeen] = useState(true);

  const checkFeatureStatus = () => {
    const value = getStoredItem(`${FEATURE_IDENTIFIER}:${feature}`);
    setIsFeatureSeen(value || false);
  };

  useEffect(() => {
    window.addEventListener(EVENT_TYPE, checkFeatureStatus);
    return () => {
      window.removeEventListener(EVENT_TYPE, checkFeatureStatus);
    };
  }, []);

  useEffect(() => {
    if (feature) {
      checkFeatureStatus();
    }
  }, [feature]);

  const setFeatureSeen = () => {
    if (feature) {
      trackUser.event('feature_notification_seen', { feature });
      setStoredItem(`${FEATURE_IDENTIFIER}:${feature}`, true);
      setIsFeatureSeen(true);

      // Dispatch a custom event so any time a feature is updated, an update
      // will be broadcast and all instances of this hook will update
      window.dispatchEvent(new Event(EVENT_TYPE));
    }
  };

  return { isFeatureSeen, setFeatureSeen };
};
